import React, {Component} from 'react';
import {Col, Row, Form, FormGroup, ControlLabel} from "react-bootstrap";
import {TopSelect} from "../../../../../componentsTopsa/selects/TopSelects";
import {TopInputDate} from "../../../../../componentsTopsa/inputs/TopInputs";
import {TopButtonAction, TopButtonAdd} from "../../../../../componentsTopsa/buttons/TopButtons";
import TopIf from "../../../../../componentsTopsa/if/TopIf";
import {TopAlertUwaga} from "../../../../../componentsTopsa/alerty/TopAlerts";
import TopDostepnosc from "../../../../../componentsTopsa/dostepnosc/TopDostepnosc";
import DateAndTimeFormat from "../../../../../utilities/DateAndTimeFormat";
import moment from "moment";

export default class PromocjeSelectForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            trasa: null,
            dataOd: null,
            dataDo: null,
            error: null,
            czyBylPrzycisk: false,

        };
        this.onChangeTrasa = this.onChangeTrasa.bind(this)
        this.onChangeDataOd = this.onChangeDataOd.bind(this)
        this.onChangeDataDo = this.onChangeDataDo.bind(this)
        this.onClickSzukaj = this.onClickSzukaj.bind(this)
    }


    componentDidMount(){

        let now = moment();
        let obecny_rok = (now.year());
        let obecny_miesiac = (now.month()) + 1;

        let pierwszy_miesiaca = moment(obecny_rok + '-' + obecny_miesiac + '-01')

        let ostatni_miesiaca = moment(obecny_rok + '-' + obecny_miesiac + '-' + moment(now).daysInMonth())

        this.setState({
            dataOd: pierwszy_miesiaca,
            dataDo: ostatni_miesiaca,
        })
    }

    onChangeTrasa(e) {
        this.setState({trasa: e})
    }

    onChangeDataOd(e) {
        this.setState({dataOd: e})
    }

    onChangeDataDo(e) {
        this.setState({dataDo: e})
    }

    onClickSzukaj() {
        this.setState({error: '', czyBylPrzycisk: true})



        if (!Boolean(this.state.dataOd) || !Boolean(this.state.dataDo)) {
            this.setState({error: 'Proszę podać zakres czasowy!'})
        }
        else if (Boolean(this.state.dataDo) && Boolean(this.state.dataOd) && this.state.dataOd > this.state.dataDo) {
            this.setState({error: 'Data od nie może być późniejsza od daty do'})
        }
        else {
            this.props.handleClickSzukaj(this.state.trasa,
                DateAndTimeFormat.formatYYYYMMDD(this.state.dataOd),
                DateAndTimeFormat.formatYYYYMMDD(this.state.dataDo))
        }
    }

    formatTrasaSelect(option) {
        return (
            <div>
                <span className={'label label-ebus-primary'}>{option.kodTrasy}</span>
                {' ' + option.nazTr}
                <TopDostepnosc wartoscWarunek={0}
                               wartosc={option.status}
                               czyMarginesLewy={true}/>
            </div>
        )
    }

    render() {
        return (
            <div>
                <Form horizontal={true}>
                    <FormGroup>
                        <Col xs={6} md={4} lg={3}>
                            <ControlLabel>Trasa</ControlLabel>
                            <TopSelect onChange={this.onChangeTrasa} value={this.state.trasa}
                                       options={this.props.trasy} labelKey={'nazTr'}
                                       valueKey={'idTr'} valueRenderer={this.formatTrasaSelect}
                                       optionRenderer={this.formatTrasaSelect}/>
                        </Col>
                        <Col xs={6} md={4} lg={2}>
                            <ControlLabel>Data rozpoczęcia od</ControlLabel>
                            <TopInputDate onChange={this.onChangeDataOd} value={this.state.dataOd}/>
                        </Col>
                        <Col xs={6} md={4} lg={2}>
                            <ControlLabel>Data rozpoczęcia do</ControlLabel>
                            <TopInputDate onChange={this.onChangeDataDo} value={this.state.dataDo}/>
                        </Col>
                        <Col xs={6} md={4} lg={3}>
                            <div className={'add-label-margin'}></div>
                            <TopButtonAction onClick={this.onClickSzukaj} iconType={'fa fa-search'} text={'Wyszukaj promocji'}/>
                        </Col>
                        <Col xs={6} md={4} lg={2}>
                            <div className={'add-label-margin'}></div>
                                <div className={'pull-right'}>
                                    <TopButtonAdd onClick={() => {
                                        this.props.handleClickDodaj()
                                    }} text={'Dodaj promocję'} buttonSize={'small'}/>
                                </div>
                        </Col>
                    </FormGroup>
                    <FormGroup>
                        <Col xs={12}>
                            <TopIf isTrue={Boolean(this.state.error)}>
                                <TopAlertUwaga text={this.state.error}/>
                            </TopIf>
                        </Col>
                    </FormGroup>
                </Form>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/biletyConfig/promocje/components/PromocjeSelectForm.js